import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";

const CTASection = () => {
  return (
    <section className="section-padding violet-glow-section">
      <div className="container-narrow text-center relative z-10">
        <Reveal className="mx-auto">
          <Button className="bg-white text-black hover:bg-black hover:text-white rounded-full px-8 py-6 text-lg font-bold transition-all duration-300 border-none" asChild>
            <Link to="/contact">Start a Project with Us</Link>
          </Button>
        </Reveal>
      </div>
    </section>
  );
};

export default CTASection;
